import React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import { Button, Grid, Tabs, Tab } from '@mui/material';
import LocationDetails from './LocationCardList';
import SlotResultPage from './SlotResultPage';
import moment from 'moment';
import { MainLocationAllocation } from '@horasys/bellplus/common/types';
import { validateSchema } from 'validations/common';
import { manualModeValidation } from 'validations/campaign.validation';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { CampaignState, UPDATE_CAMPAIGN_AD_UI_STATE, getLocationSearchByArea, getMainLocationManualResult } from 'Stores/Slices/campaignSlice';
import { RootState } from 'Stores/store';
const PREFIX = 'LocationManualMode';

const classes = {
    paperchildGrid: `${PREFIX}-paperchildGrid`,
    searchLocations: `${PREFIX}-searchLocations`,
    slotResultsPage: `${PREFIX}-slotResultsPage`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.paperchildGrid}`]: {
        padding: theme.spacing(1),
    },

    [`& .${classes.searchLocations}`]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        minWidth: '50%',
    },

    [`& .${classes.slotResultsPage}`]: {
        marginTop: theme.spacing(3),
        height: '100%',
        padding: theme.spacing(3),
    }
}));

export const LocationManualMode = ({
	modalDialogViewMode,
	error,
	setError,
}: {
	modalDialogViewMode: boolean;
	error: any;
	setError: any;
}) => {
	const dispatch = useAppDispatch();
	const campaignStore: CampaignState = useAppSelector((state: RootState) => state.campaign);
	const {
		campaignAdvertisementForm: advForm,
		campaignAdvertisementState,
	} = campaignStore;
	const locationDetails = advForm.searchLocations;
	const slotResults = advForm.selectedLocations;
	const { tabValue } = campaignAdvertisementState;

	function TabPanel(props: any) {
		const { children, value, index, ...other } = props;

		return (
			<Grid
				xs={12}
				container
				role="tabpanel"
				hidden={value !== index}
				id={`full-width-tabpanel-${index}`}
				aria-labelledby={`full-width-tab-${index}`}
				{...other}>
				{value === index && children}
			</Grid>
		);
	}

	const manualModeSubmitHandler = async (result: any) => {
		const requestObj: any = {
			startDate: moment(advForm.startDate).format('YYYY-MM-DD'),
			endDate: moment(advForm.endDate).format('YYYY-MM-DD'),
			advertisementId: advForm.advertisement.id,
			locations: [],
			uuid: advForm.uuid,
		};

		advForm.searchLocations.forEach((loc: MainLocationAllocation) => {
			if (loc.added) {
				requestObj.locations.push({
					mainLocationId: loc.id,
					selectedDeviceCount: loc.selectedDevices,
					noOfTimes: loc.noOfTimes,
				});
			}
		});
		dispatch(getMainLocationManualResult(requestObj));
	};

	const handleSearchLocations = async () => {
		const requestObj = {
			startDate: moment(advForm.startDate).format('YYYY-MM-DD'),
			endDate: moment(advForm.endDate).format('YYYY-MM-DD'),
			areas: advForm.selectedAreas,
			advertisementId: advForm.advertisement.id,
		};
		try {
			await validateSchema(manualModeValidation, requestObj);
			setError({});
			dispatch(getLocationSearchByArea(requestObj));
		} catch (errorObj) {
			console.warn(' error', errorObj);
			setError(errorObj);
		}
	};


	return (
        <Root>
            <Grid item container xs={12} justifyContent="center" style={{margin:'0 auto', width:'500px'}}>
                <Grid
                    item
                    container
                    xs={12}
                    className={classes.paperchildGrid}

                    justifyContent="center">
                    <Button
                    style={{color:"#042630",borderColor:"#91a0a4"}}
                        className={classes.searchLocations}
                        variant="outlined"
                        color="primary"
                        disabled={modalDialogViewMode}
                        onClick={handleSearchLocations}>
                        Search Locations
                    </Button>
                </Grid>
            </Grid>
            {locationDetails && locationDetails.length > 0 && (
                <Grid item container xs={12}
                >
                    <AppBar position="static" color="default">
                        <Tabs
                        style={{ width:'1454px'}}
                            value={tabValue}
                            onChange={(e, value) =>
                                dispatch(UPDATE_CAMPAIGN_AD_UI_STATE({ tabValue: value }))
                            }

                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example">
                            <Tab label="Select Devices" id="selectdevices" />
                            <Tab label="Result" id="result" />
                        </Tabs>
                    </AppBar>
                    <TabPanel value={tabValue} index={0}>
                        <Grid item container xs={12}>
                            <LocationDetails
                                modalDialogViewMode={modalDialogViewMode}
                                handleSlotBookHandler={manualModeSubmitHandler}
                            />
                        </Grid>
                    </TabPanel>
                    <TabPanel
                        value={tabValue}
                        index={1}
                        disabled={slotResults.length === 0}>
                        <Grid item container xs={12} className={classes.slotResultsPage}>
                            <SlotResultPage slotResults={slotResults} />
                        </Grid>
                    </TabPanel>
                </Grid>
            )}
        </Root>
    );
};
